import {
    GET_LIST_CUSTOMER_INTERACTIVE_STATUS,
    GET_SPECIFIC_CUSTOMER_INTERACTIVE_STATUS,
    UPDATE_SPECIFIC_CUSTOMER_INTERACTIVE_STATUS,
    CREATE_NEW_CUSTOMER_INTERACTIVE_STATUS,
    REMOVE_CUSTOMER_INTERACTIVE_STATUS,
    GET_CUSTOMER_INTERACTIVE_STATUS_ACTIVE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    customerInteractiveStatusList: [],
    currentCustomerInteractiveStatus: null,
    customerInteractiveStatusActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CUSTOMER_INTERACTIVE_STATUS: {
            return {
                ...state,
                customerInteractiveStatusList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_CUSTOMER_INTERACTIVE_STATUS_ACTIVE: {
            return {
                ...state,
                customerInteractiveStatusActiveList: action.payload?.data || [],
            }
        }
        case GET_SPECIFIC_CUSTOMER_INTERACTIVE_STATUS: {
            return { ...state, currentCustomerInteractiveStatus: action.payload }
        }
        case CREATE_NEW_CUSTOMER_INTERACTIVE_STATUS: {
            return {
                ...state,
                customerInteractiveStatusList: [action.payload, ...state.customerInteractiveStatusList],
                customerInteractiveStatusActiveList: [action.payload, ...state.customerInteractiveStatusActiveList],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_CUSTOMER_INTERACTIVE_STATUS: {
            let index = state.customerInteractiveStatusList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.customerInteractiveStatusList];
            temp[index] = action.payload;
            //
            let index2 = state.customerInteractiveStatusActiveList.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp2 = [...state.customerInteractiveStatusActiveList];
            temp[index2] = action.payload;

            return { ...state, customerInteractiveStatusList: temp, customerInteractiveStatusActiveList: temp2 }
        }
        case REMOVE_CUSTOMER_INTERACTIVE_STATUS: {
            let temp = state.customerInteractiveStatusList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.customerInteractiveStatusActiveList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, customerInteractiveStatusList: temp, customerInteractiveStatusActiveList: temp2 }
        }
        default: return { ...state };
    }
}
